import {call, put, select, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  storeDataExplorerAnalysis,
  storeDataExplorerTemplates,
  storeDataExplorerTimezones,
  storeDataExplorerSnapshot,
} from "../Actions/data-explorer.actions";
import {
  getDataExplorerAnalysisAsync,
  getDataExplorerTemplatesAsync,
  getDataExplorerTimezonesAsync,
  saveDataExplorerSnapshotAsync,
  getDataExplorerSnapshotsAsync,
} from "../AsyncActions/data-explorer.async";
import {getSelectedController} from "../Selectors/controllers.selectors";

function* requestDataExplorerTemplates(action = {}) {
  const {payload, callback} = action;
  try {
    const response = yield call(getDataExplorerTemplatesAsync, {
      data: payload,
    });
    if (response?.data) {
      yield put(storeDataExplorerTemplates(response.data.results));
      if (callback) callback(response.data.results);
    }
  } catch (e) {
    //
  }
}

function* requestDataExplorerAnalysis(action = {}) {
  const {payload} = action;
  try {
    const response = yield call(getDataExplorerAnalysisAsync, {
      data: payload,
    });
    if (response?.data?.data) {
      yield put(storeDataExplorerAnalysis(response?.data?.data));
    }
  } catch (e) {
    //
  }
}

function* requestDataExplorerTimezones(action = {}) {
  const {payload, callback} = action;
  try {
    const response = yield call(getDataExplorerTimezonesAsync, {
      data: payload,
    });
    if (response?.data) {
      yield put(storeDataExplorerTimezones(response.data.results));
      if (callback) callback(response.data.results);
    }
  } catch (e) {
    //
  }
}

function* requestDataExplorerSnapshot(action = {}) {
  const {callback} = action;
  const selectedController = yield select(getSelectedController);

  try {
    const response = yield call(getDataExplorerSnapshotsAsync, selectedController.mac);
    if (response.data) {
      yield put(storeDataExplorerSnapshot(response.data));
      if (callback) callback(response.data);
    }
  } catch (e) {
    //
  }
}

function* saveDataExplorerSnapshot(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(saveDataExplorerSnapshotAsync, {
      dashboard_id: payload?.id,
      data: payload,
    });
    if (response) {
      callback();
    }
  } catch (e) {
    //
  }
}

export function* dataExplorerSaga() {
  yield takeLatest(actions.REQUEST_DATA_EXPLORER_TEMPLATES, requestDataExplorerTemplates);
  yield takeLatest(actions.REQUEST_DATA_EXPLORER_ANALYSIS, requestDataExplorerAnalysis);
  yield takeLatest(actions.REQUEST_DATA_EXPLORER_TIMEZONES, requestDataExplorerTimezones);
  yield takeLatest(actions.REQUEST_DATA_EXPLORER_SNAPSHOT, requestDataExplorerSnapshot);
  yield takeLatest(actions.SAVE_DATA_EXPLORER_SNAPSHOT, saveDataExplorerSnapshot);
}
